import React, { useMemo } from 'react';
import { Link, Route, Switch, Redirect } from 'react-router-dom';

import artisans from './artisans';
import products from './artisanProducts';
import Jobs from './artisanJobs';
import privateInquiry from './privateInquirey';
import publicInquiry from './publicInquirey';
import privateProposals from './privateProposal';
import publicProposals from './publicProposal';
import Content from '../../../_psb/layout/Content';
import SubHeader from '../../../_psb/layout/sub-header/SubHeader';

import Tabs from '../../../components/UI/tab/Tabs';
import getLangData from '../../../utils/getLangData';

const ArtisansModeration = () => {
  const lang = getLangData().general_words

  const tabsProps = useMemo(() => ({
    base: '/artisans-moderation',
    items: [
      { title: lang.artisan, page: '/artisans' },
      { title: lang.products, page: '/products' },
      { title: lang.jobs, page: '/jobs' },
      { title: lang.public_inquiry, page: '/public-inquiry' },
      { title: lang.private_inquiry, page: '/private-inquiry' },
      { title: lang.private_proposal, page: '/private-proposal' },
      { title: lang.public_proposal, page: '/public-proposal' }
    ]
  }));
  return (
    <>
      <SubHeader title={lang.pending_artisans}>

      </SubHeader>

      <div className='d-flex justify-content-center my-3'>
        <Switch>
          <Route
            exact
            path='/artisans-moderation/:name'
            render={() => <Tabs {...tabsProps} />}
          />

          {/* <Route
            exact
            path='/artisans-moderation/:name/:id'
            render={({ match: { params } }) => {
              return (
                <Link
                  to={`/artisans-moderation/${params.name}`}
                  className='btn-label-brand btn btn-bold'
                >
                  Back To List
                </Link>
              );
            }}
          /> */}
        </Switch>
      </div>
      {/* <Content> */}
      <>
        <Switch>
          <Redirect
            exact
            from='/artisans-moderation'
            to='/artisans-moderation/artisans'
          />

          {/* <Redirect
            exact
            from='/artisans-moderation/:name/:id'
            to='/artisans-moderation/:name'
          /> */}

          {/**
           * Artisans
           */}

          <Route
            exact
            path={[
              '/artisans-moderation/artisans',
              '/artisans-moderation/artisans/:artisanId'
            ]}
            component={artisans}
          />

          {/**
           * Products
           */}

          <Route
            exact
            path={[
              '/artisans-moderation/products',
              '/artisans-moderation/products/:id'
            ]}
            component={products}
          />

          <Route
            exact
            path={[
              '/artisans-moderation/jobs',
              '/artisans-moderation/jobs/:id'
            ]}
            component={Jobs}
          />
          {/**
           * Public Inquiry
           */}

          <Route
            exact
            path={[
              '/artisans-moderation/public-inquiry',
              '/artisans-moderation/public-inquiry/:id'
            ]}
            component={publicInquiry}
          />

          {/**
           * Private Inquiry
           */}
          <Route
            exact
            path={[
              '/artisans-moderation/private-inquiry',
              '/artisans-moderation/private-inquiry/:id'
            ]}
            component={privateInquiry}
          />
          <Route
            exact
            path={[
              '/artisans-moderation/private-proposal',
              '/artisans-moderation/private-proposal/:id'
            ]}
            component={privateProposals}
          />

          <Route
            exact
            path={[
              '/artisans-moderation/public-proposal',
              '/artisans-moderation/public-proposal/:id'
            ]}
            component={publicProposals}
          />
        </Switch>
      </>
      {/* </Content> */}
    </>
  );
};

export default ArtisansModeration;
